import { Loader2 } from "lucide-react";
import { useMyClass } from "@/hooks/myClass";

const MyClass: React.FC = () => {
  const {
    myCourses,
    loading,
    error,
    downloadingId,
    defaultImage,
    navigate,
    handleDownloadCertificate,
  } = useMyClass();

  if (loading) {
    return (
      <div className="flex flex-col items-center justify-center min-h-[400px]">
        <Loader2 className="w-8 h-8 animate-spin text-[#D32F2F] mb-4" />
        <p className="text-gray-500 text-sm">Loading classes...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="p-8 text-center bg-red-50 rounded-lg border border-red-100">
        <p className="text-[#D32F2F] font-medium">{error}</p>
      </div>
    );
  }

  return (
    <div className="font-sans max-w-5xl mx-auto py-10 px-6">
      {/* HEADER */}
      <div className="mb-12">
        <p className="text-gray-500 text-sm font-normal mb-1">
          Your Learning Access
        </p>
        <h1 className="text-4xl font-bold text-gray-900 tracking-tight">
          My Classes
        </h1>
      </div>

      {/* LIST ITEM */}
      <div className="space-y-12">
        {myCourses.length > 0 ? (
          myCourses.map((course, index) => {
            const displayTitle = course.title
              ? course.title
              : `Course Level ${course.level || "General"}`;

            return (
              <div
                key={`${course.id}-${index}`}
                className="flex flex-col md:flex-row gap-8 items-start group"
              >
                {/* 1. IMAGE */}
                <div className="w-full md:w-[280px] h-[180px] bg-gradient-to-br from-[#D32F2F] to-[#FF5252] rounded-2xl flex-shrink-0 relative overflow-hidden">
                  <img
                    src={defaultImage}
                    alt={displayTitle}
                    className="absolute bottom-0 right-0 w-[90%] h-[90%] object-contain object-right-bottom"
                  />
                </div>

                {/* 2. CONTENT */}
                <div className="flex-1 py-1">
                  {/* --- [BADGES CONTAINER] --- */}
                  {/* Semua badge dipaksa muncul (tanpa kondisi if) */}
                  <div className="flex flex-wrap items-center gap-2 mb-3">
                    {/* 1. Completed */}
                    <span className="px-3 py-1 bg-[#E8F5E9] text-[#1B5E20] text-[12px] font-semibold rounded-full">
                      Completed
                    </span>

                    {/* 2. Active (Selalu Muncul) */}
                    <span className="px-3 py-1 bg-[#E8F5E9] text-[#1B5E20] text-[12px] font-semibold rounded-full">
                      Active
                    </span>

                    {/* 3. Paid (Selalu Muncul) */}
                    <span className="px-3 py-1 bg-[#E8F5E9] text-[#1B5E20] text-[12px] font-semibold rounded-full">
                      Paid
                    </span>
                  </div>

                  {/* --- TITLE --- */}
                  <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-1 leading-snug">
                    {displayTitle}
                  </h3>

                  {/* --- STATUS TEXT --- */}
                  <div className="flex items-center gap-2 mb-6">
                    <div className="w-2.5 h-2.5 rounded-full bg-green-500 animate-pulse"></div>
                    <span className="text-gray-500 text-sm font-normal">
                      Currently in progress
                    </span>
                  </div>

                  {/* Buttons */}
                  <div className="flex flex-wrap gap-3">
                    <button
                      className="px-6 py-2.5 bg-[#D32F2F] hover:bg-red-700 text-white font-bold rounded-lg text-sm transition-all shadow-md shadow-red-100"
                      onClick={() => navigate(`/user/class/${course.id}`)}
                    >
                      View Class
                    </button>

                    {course.progress < 0 && (
                      <button
                        onClick={() =>
                          handleDownloadCertificate(
                            course.certificate_file!,
                            course.id,
                            displayTitle,
                            course.user_name,
                          )
                        }
                        disabled={downloadingId === course.id}
                        className="px-6 py-2.5 bg-white border border-[#D32F2F] hover:bg-red-50 text-[#D32F2F] font-bold rounded-lg text-sm transition-colors flex items-center gap-2"
                      >
                        {downloadingId === course.id ? (
                          <>
                            <Loader2 className="w-4 h-4 animate-spin" />{" "}
                            Downloading...
                          </>
                        ) : (
                          "Certificate"
                        )}
                      </button>
                    )}
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <div className="w-full bg-[#E8F5E9] rounded-2xl p-6 md:p-8">
            <p className="text-gray-800 font-medium text-sm md:text-base leading-relaxed">
              Tidak ada kelas yang selesai atau memiliki sertifikat.
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default MyClass;
